import { render, staticRenderFns } from "./templateC.vue?vue&type=template&id=54bbbf76&scoped=true"
import script from "./templateC.vue?vue&type=script&lang=js"
export * from "./templateC.vue?vue&type=script&lang=js"
import style0 from "./templateC.vue?vue&type=style&index=0&id=54bbbf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbbf76",
  null
  
)

export default component.exports